import { Log, UserManager } from 'oidc-client-ts';

export const handleSilentSigninRedirectInIframe = async (loginConfig: {
    authority: string;
    clientId: string;
    redirectUri: string;
}) => {
    // Login redirects that do not happen in an iframe are handled in the main app.
    // See doSignIn() in initialSignin.ts
    Log.setLogger(console);
    Log.setLevel(Log.INFO);

    // Notify the parent window of response (callback) from the authorization endpoint.
    // Only a minimal usermanager is required here.
    const userManager = new UserManager({
        authority: loginConfig.authority,
        client_id: loginConfig.clientId,
        redirect_uri: loginConfig.redirectUri,
    });

    await userManager.signinCallback();
};
